import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    checkedUnit: {},
    filterType: "byUser",
    searchValue: "",
    users: [],
    checkedUsers: []
};

const [
    viewModel,
    update, reset,

] = BaseUtil.getViewModel(initState, type);

export {
    update, reset,
};
export default viewModel;